
















import Card from '@/components/Card.vue'
import { CLAIMS_URL } from '@/config'

export default {
  components: {
    Card
  },
  props: {
    currentUser: { type: Object, required: true },
    carrierCompany: { type: Object, required: true },
    orderReference: { type: String, required: true }
  },
  computed: {
    claimsUrl(): string {
      const requestParams = {
        utm_source: 'orcas',
        language: this.$i18n.locale,
        email: this.currentUser.username,
        company: this.carrierCompany.name,
        sennderReference: this.orderReference
      }
      const searchParams = new URLSearchParams(requestParams)
      return `${CLAIMS_URL}?${searchParams}`
    }
  }
}
